// extracted by mini-css-extract-plugin
export default {"welcomeText":"Login_welcomeText__wEBVR","loginContainer":"Login_loginContainer__r74oZ"};